import axios from 'axios';
import * as types from './Editor.types';
import * as selectors from './Editor.selectors';
import { showNotification } from './../../utils';
import * as loginActions from './../Login/Login.actions';
import * as loginSelectors from './../Login/Login.selectors';
import { getCanvasValues, isEmpty } from './../Editor/CanvasActions';

const apiUrl = process.env.REACT_APP_API_URL;

export const addToCart = (orderType = 1, history, type = 1) => (dispatch, getState) => {
    const user = loginSelectors.getUser(getState());
    const cxmlData = loginSelectors.getCxmlData(getState());
    const templateCode = selectors.getTemplateCode(getState());
    const quantity = selectors.getQuantity(getState());
    const action = selectors.getAction(getState());

    const name = selectors.getName(getState());
    const credentials = selectors.getCredentials(getState());
    const title1 = selectors.getTitle1(getState());
    const title2 = selectors.getTitle2(getState());
    const title3 = selectors.getTitle3(getState());
    const department1 = selectors.getDepartment1(getState());
    const department2 = selectors.getDepartment2(getState());
    const department3 = selectors.getDepartment3(getState());
    const phone = selectors.getPhone(getState());
    const fax = selectors.getFax(getState());
    const nursePhone = selectors.getNursePhone(getState());
    const fontType = selectors.getFontType(getState());
    const address = selectors.getAddress(getState());
    const address2 = selectors.getAddress2(getState());
    const address3 = selectors.getAddress3(getState());
    const city = selectors.getCity(getState());
    const state = selectors.getState(getState());
    const zip = selectors.getZip(getState());
    const email = selectors.getEmail(getState());
    const open1 = selectors.getOpen1(getState());
    const open2 = selectors.getOpen2(getState());
    const open3 = selectors.getOpen3(getState());
    const frontDataUrl = selectors.getFrontDataUrl(getState());
    const backDataUrl = selectors.getBackDataUrl(getState());
    const locationNames = selectors.getLocationNames(getState());
    const locationPhones = selectors.getLocationPhones(getState());
    const locationFaxes = selectors.getLocationFaxes(getState());
    const locationNursePhones = selectors.getLocationNursePhones(getState());
    const locationAddresses1 = selectors.getLocationAddresses1(getState());
    const locationAddresses2 = selectors.getLocationAddresses2(getState());
    const locationAddresses3 = selectors.getLocationAddresses3(getState());
    const locationCities = selectors.getLocationCities(getState());
    const locationStates = selectors.getLocationStates(getState());
    const locationZips = selectors.getLocationZips(getState());
    const locationSuites = selectors.getLocationSuites(getState());
    const clinic = selectors.getClinic(getState());
    const pager = selectors.getPager(getState());
    const showEmail = selectors.getShowEmail(getState());
    const cell = selectors.getCell(getState());
    const showCell = selectors.getShowCell(getState());
    const color = selectors.getColor(getState());
    const stock = selectors.getStock(getState());
    const titles = selectors.getTitles(getState());
    const personsNames = selectors.getPersonsNames(getState());
    const personsTitles = selectors.getPersonsTitles(getState());
    const notes = selectors.getNotes(getState());
    const contact1Phone = selectors.getContact1Phone(getState());
    const contact1Type = selectors.getContact1Type(getState());
    const contact2Phone = selectors.getContact2Phone(getState());
    const contact2Type = selectors.getContact2Type(getState());
    const locationsState = selectors.getLocations(getState());
    const quantity1 = selectors.getQuantity1(getState());
    const quantity2 = selectors.getQuantity2(getState());
    const quantity3 = selectors.getQuantity3(getState());
    const front = selectors.getFront(getState());
    const back = selectors.getBack(getState());
    const suiteRoom = selectors.getSuiteRoom(getState());
    const firstName = selectors.getFirstName(getState());
    const middleName = selectors.getMiddleName(getState());
    const lastName = selectors.getLastName(getState());
    const primaryTitle = selectors.getPrimaryTitle(getState());
    const secondaryTitle = selectors.getSecondaryTitle(getState());
    const title4 = selectors.getTitle4(getState());
    const main = selectors.getMain(getState());
    const direct = selectors.getDirect(getState());
    const website = selectors.getWebsite(getState());
    const schedulingCard = selectors.getSchedulingCard(getState());
    const addEnvelopes = selectors.getAddEnvelopes(getState());
    const letterheadPersons = selectors.getLetterheadPersons(getState());
    const prescriptionPadDoctors = selectors.getPrescriptionPadDoctors(getState());
    const window = selectors.getWindow(getState());
    const showSocialMediaIcons = selectors.getShowSocialMediaIcons(getState());
    const additionalField = selectors.getAdditionalField(getState());
    const phoneLabel1 = selectors.getPhoneLabel1(getState());
    const phoneLabel2 = selectors.getPhoneLabel2(getState());
    const phoneLabel3 = selectors.getPhoneLabel3(getState());
    const phoneOtherLabel1 = selectors.getPhoneOtherLabel1(getState());
    const phoneOtherLabel2 = selectors.getPhoneOtherLabel2(getState());
    const phoneOtherLabel3 = selectors.getPhoneOtherLabel3(getState());
    const language = selectors.getLanguage(getState());
    const clinicId = selectors.getClinicId(getState());
    const clinics = selectors.getClinics(getState());
    const clinicLocations = selectors.getClinicLocations(getState());

    var formData = new FormData();
    formData.append('userId', user.id);
    formData.append('orderType', orderType);
    formData.append('productType', 1);
    formData.append('quantity', quantity);

    formData.append('templateCode', templateCode);
    formData.append('name', name);
    formData.append('credentials', credentials);
    formData.append('title1', title1);
    formData.append('title2', title2);
    formData.append('title3', title3);
    formData.append('department1', department1);
    formData.append('department2', department2);
    formData.append('department3', department3);
    formData.append('phone', phone);
    formData.append('fax', fax);
    formData.append('nursePhone', nursePhone);
    formData.append('fontType', fontType);
    formData.append('address', address);
    formData.append('address2', address2);
    formData.append('address3', address3);
    formData.append('city', city);
    formData.append('state', state);
    formData.append('zip', zip);
    formData.append('email', email);
    formData.append('open1', open1);
    formData.append('open2', open2);
    formData.append('open3', open3);
    formData.append('locations', locationsState);
    formData.append('front', front);
    formData.append('back', back);
    formData.append('suiteRoom', suiteRoom);
    formData.append('firstName', firstName);
    formData.append('middleName', middleName);
    formData.append('lastName', lastName);
    formData.append('primaryTitle', primaryTitle);
    formData.append('secondaryTitle', secondaryTitle);
    formData.append('title4', title4);
    formData.append('main', main);
    formData.append('direct', direct);
    formData.append('website', website);
    formData.append('schedulingCard', schedulingCard);
    formData.append('window', window);
    formData.append('additionalField', additionalField);
    formData.append('phoneLabel1', phoneLabel1);
    formData.append('phoneLabel2', phoneLabel2);
    formData.append('phoneLabel3', phoneLabel3);
    formData.append('phoneOtherLabel1', phoneOtherLabel1);
    formData.append('phoneOtherLabel2', phoneOtherLabel2);
    formData.append('phoneOtherLabel3', phoneOtherLabel3);
    formData.append('showSocialMediaIcons', showSocialMediaIcons);

    let locations = 0;
    if (templateCode === 'p1t5') {
        locations = 3;
    } else if (templateCode === 'p1t6') {
        locations = 2;
    } else if (templateCode === 'p1t9') {
        locations = locationsState;
    } else if (templateCode === 'p1t13') {
        locations = locationsState;
    } else if (templateCode === 'p1t16') {
        locations = locationsState;
    }

    for (let i = 0; i < locations; i++) {
        if (!isEmpty(locationNames[i])) {
            formData.append('locationName' + (i + 1), locationNames[i]);
        }
        if (!isEmpty(locationPhones[i])) {
            formData.append('locationPhone' + (i + 1), locationPhones[i]);
        }
        if (!isEmpty(locationFaxes[i])) {
            formData.append('locationFax' + (i + 1), locationFaxes[i]);
        }
        if (!isEmpty(locationNursePhones[i])) {
            formData.append('locationNursePhone' + (i + 1), locationNursePhones[i]);
        }
        if (!isEmpty(locationAddresses1[i])) {
            formData.append('locationAddress1' + (i + 1), locationAddresses1[i]);
        }
        if (!isEmpty(locationAddresses2[i])) {
            formData.append('locationAddress2' + (i + 1), locationAddresses2[i]);
        }
        if (!isEmpty(locationAddresses3[i])) {
            formData.append('locationAddress3' + (i + 1), locationAddresses3[i]);
        }
        if (!isEmpty(locationCities[i])) {
            formData.append('locationCity' + (i + 1), locationCities[i]);
        }
        if (!isEmpty(locationStates[i])) {
            formData.append('locationState' + (i + 1), locationStates[i]);
        }
        if (!isEmpty(locationZips[i])) {
            formData.append('locationZip' + (i + 1), locationZips[i]);
        }
        if (!isEmpty(locationSuites[i])) {
            formData.append('locationSuite' + (i + 1), locationSuites[i]);
        }
    }

    formData.append('frontDataUrl', frontDataUrl);
    formData.append('backDataUrl', backDataUrl);
    formData.append('clinic', clinic);
    formData.append('pager', pager);
    formData.append('showEmail', showEmail);
    formData.append('nameDivided', getCanvasValues().nameDivided);
    formData.append('name1', getCanvasValues().name1);
    formData.append('name2', getCanvasValues().name2);
    formData.append('cell', cell);
    formData.append('showCell', showCell);
    formData.append('color', color);
    formData.append('stock', stock);
    formData.append('notes', notes);
    formData.append('contact1Phone', contact1Phone);
    formData.append('contact1Type', contact1Type);
    formData.append('contact2Phone', contact2Phone);
    formData.append('contact2Type', contact2Type);
    formData.append('quantity1', quantity1);
    formData.append('quantity2', quantity2);
    formData.append('quantity3', quantity3);
    formData.append('frontDividers', JSON.stringify(getCanvasValues().frontDividers));
    formData.append('backDividers', JSON.stringify(getCanvasValues().backDividers));
    formData.append('addressSize', getCanvasValues().addressSize);
    formData.append('nameSize', getCanvasValues().nameSize);
    formData.append('titlesSize', getCanvasValues().titlesSize);
    formData.append('yStep', getCanvasValues().yStep);
    formData.append('sectionStep', getCanvasValues().sectionStep);
    formData.append('phoneLabelSize', getCanvasValues().phoneLabelSize);
    formData.append('phoneLabelX', getCanvasValues().phoneLabelX);
    formData.append('phoneLabelY', getCanvasValues().phoneLabelY);
    formData.append('addEnvelopes', addEnvelopes);
    formData.append('letterheadPersons', JSON.stringify(letterheadPersons));
    formData.append('prescriptionPadDoctors', JSON.stringify(prescriptionPadDoctors));
    formData.append('language', language);
    formData.append('clinicId', clinicId);

    let clinicName = '';
    for (let i = 0; i < clinics.length; i++) {
        if (parseInt(clinicId) === parseInt(clinics[i].id)) {
            clinicName = clinics[i].name;
            break;
        }
    }
    formData.append('clinicName', clinicName);

    let locationAddress = '';
    if (clinicLocations.length > 0) {
        locationAddress = clinicLocations[0].name;
    }
    formData.append('locationAddress', locationAddress);

    formData.append('cxml_id', cxmlData.id);
    formData.append('cxml_buyer_cookie', cxmlData.buyer_cookie);
    formData.append('cxml_browser_form_post', cxmlData.browser_form_post);
    formData.append('cxml_supplier_domain', cxmlData.supplier_domain);
    formData.append('cxml_supplier_id', cxmlData.supplier_id);
    formData.append('cxml_buyer_domain', cxmlData.buyer_domain);
    formData.append('cxml_buyer_id', cxmlData.buyer_id);

    if (['p10t1', 'p10t2', 'p10t3', 'p10t4', 'p10t5', 'p10t6', 'p10t7', 'p10t8', 'p10t9', 'p10t10'].includes(templateCode)) {
        for (let i = 0; i < titles.length; i++) {
            formData.append('titles' + (i + 1), titles[i]);
        }
        for (let i = 0; i < personsNames.length; i++) {
            formData.append('personsNames' + (i + 1), personsNames[i]);
        }
        for (let i = 0; i < personsTitles.length; i++) {
            formData.append('personsTitles' + (i + 1), personsTitles[i]);
        }
    }

    formData.append('action', action);
    formData.append('type', type);
    if (action === 'edit') {
        formData.append('editId', localStorage.getItem('id'));
    }

    dispatch({ type: types.ADD_TO_CART, payload: type });
    axios.post(apiUrl + '/uthealth-shopping-cart-items', formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.ADD_TO_CART_SUCCESS, payload: response.data });
            dispatch(setAddToCartOrderType(null));
            dispatch(setAddToCartType(null));

            if (parseInt(type) === 1) {
                showNotification('Success', 'The item was added to your cart', 'success');
            } else if (parseInt(type) === 2) {
                showNotification('Success', 'The item has been saved into your shopping cart for future edit', 'success', 6000);
            }
            history.push('/shopping-cart');
        })
        .catch((error) => {
            dispatch({ type: types.ADD_TO_CART_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const addFavorite = (history) => (dispatch, getState) => {
    const user = loginSelectors.getUser(getState());
    const cxmlData = loginSelectors.getCxmlData(getState());
    const templateCode = selectors.getTemplateCode(getState());

    var formData = new FormData();
    formData.append('userId', user.id);
    formData.append('productType', 1);
    formData.append('templateCode', templateCode);
    formData.append('pathname', history.location.pathname);

    formData.append('cxml_id', cxmlData.id);
    formData.append('cxml_buyer_cookie', cxmlData.buyer_cookie);
    formData.append('cxml_browser_form_post', cxmlData.browser_form_post);
    formData.append('cxml_supplier_domain', cxmlData.supplier_domain);
    formData.append('cxml_supplier_id', cxmlData.supplier_id);
    formData.append('cxml_buyer_domain', cxmlData.buyer_domain);
    formData.append('cxml_buyer_id', cxmlData.buyer_id);

    dispatch({ type: types.ADD_FAVORITE, payload: null });
    axios.post(apiUrl + '/uthealth-favorite/add-favorite', formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.ADD_FAVORITE_SUCCESS, payload: response.data });

            if (parseInt(response.data.type) === 1) {
                showNotification('Success', 'The item has been added to your Favorites', 'success');
            } else {
                showNotification('Success', 'The item has been removed from your Favorites', 'success');
            }
        })
        .catch((error) => {
            dispatch({ type: types.ADD_FAVORITE_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const checkFavorite = (templateCode) => (dispatch, getState) => {
    const user = loginSelectors.getUser(getState());
    const cxmlData = loginSelectors.getCxmlData(getState());

    var formData = new FormData();
    formData.append('userId', user.id);
    formData.append('productType', 1);
    formData.append('templateCode', templateCode);

    formData.append('cxml_id', cxmlData.id);
    formData.append('cxml_buyer_cookie', cxmlData.buyer_cookie);
    formData.append('cxml_browser_form_post', cxmlData.browser_form_post);
    formData.append('cxml_supplier_domain', cxmlData.supplier_domain);
    formData.append('cxml_supplier_id', cxmlData.supplier_id);
    formData.append('cxml_buyer_domain', cxmlData.buyer_domain);
    formData.append('cxml_buyer_id', cxmlData.buyer_id);

    dispatch({ type: types.CHECK_FAVORITE, payload: null });
    axios.post(apiUrl + '/uthealth-favorite/check-favorite', formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.CHECK_FAVORITE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.CHECK_FAVORITE_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const fetchCheckControl = () => (dispatch, getState) => {
    dispatch({ type: types.FETCH_CHECK_CONTROL, payload: null });
    axios.get(apiUrl + '/uthealth-shopping-cart-item/check-control',
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_CHECK_CONTROL_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_CHECK_CONTROL_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const fetchClinics = () => (dispatch) => {
    dispatch({ type: types.FETCH_CLINICS, payload: null });
    axios.get(apiUrl + '/uthealth-myuthealth-clinics',
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_CLINICS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_CLINICS_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const fetchClinicLocations = (id) => (dispatch) => {
    dispatch({ type: types.FETCH_CLINIC_LOCATIONS, payload: null });
    axios.get(apiUrl + '/uthealth-myuthealth-locations?id=' + id,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_CLINIC_LOCATIONS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_CLINIC_LOCATIONS_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const checkAvailableItems = (clinicId, templateCode, language) => (dispatch) => {
    dispatch({ type: types.CHECK_AVAILABLE_ITEMS, payload: null });
    axios.post(apiUrl + '/uthealth-clinical-signage-order/check-available', {
        uthealth_clinic_id: clinicId,
        template_code: templateCode,
        language: language,
    }, { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.CHECK_AVAILABLE_ITEMS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.CHECK_AVAILABLE_ITEMS_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const loadVariables = () => (dispatch, getState) => {
    if (localStorage.getItem('variables') != null) {
        const productType = localStorage.getItem('productType');
        const quantity = localStorage.getItem('quantity');
        const variables = JSON.parse(localStorage.getItem('variables'));

        if (parseInt(productType) === 1) {    // Variable
            dispatch(setQuantity(quantity));
            dispatch(setAddress(variables.address));
            dispatch(setAddress2(variables.address2));
            dispatch(setAddress3(variables.address3));
            dispatch(setCell(variables.cell));
            dispatch(setCity(variables.city));
            dispatch(setClinic(variables.clinic));
            dispatch(setColor(variables.color));
            dispatch(setContact1Phone(variables.contact1Phone));
            dispatch(setContact1Type(variables.contact1Type));
            dispatch(setContact2Phone(variables.contact2Phone));
            dispatch(setContact2Type(variables.contact2Type));
            dispatch(setCredentials(variables.credentials));
            dispatch(setDepartment1(variables.department1));
            dispatch(setDepartment2(variables.department2));
            dispatch(setDepartment3(variables.department3));
            dispatch(setEmail(variables.email));
            dispatch(setFax(variables.fax));
            dispatch(setName(variables.name));
            dispatch(setNotes(variables.notes));
            dispatch(setOpen1(variables.open1));
            dispatch(setOpen2(variables.open2));
            dispatch(setOpen3(variables.open3));
            dispatch(setPager(variables.pager));
            dispatch(setPhone(variables.phone));
            dispatch(setShowCell(variables.showCell));
            dispatch(setShowEmail(variables.showEmail));
            dispatch(setState(variables.state));
            dispatch(setStock(variables.stock));
            dispatch(setTitle1(variables.title1));
            dispatch(setTitle2(variables.title2));
            dispatch(setTitle3(variables.title3));
            dispatch(setZip(variables.zip));
            dispatch(setLocations(variables.locations));
            dispatch(setQuantity1(variables.quantity1));
            dispatch(setQuantity2(variables.quantity2));
            dispatch(setQuantity3(variables.quantity3));
            dispatch(setNursePhone(variables.nursePhone));
            dispatch(setFontType(variables.fontType));

            let locationNames = [];
            if (variables.locationName1) {
                locationNames[0] = variables.locationName1;
            }
            if (variables.locationName2) {
                locationNames[1] = variables.locationName2;
            }
            if (variables.locationName3) {
                locationNames[2] = variables.locationName3;
            }

            let locationPhones = [];
            if (variables.locationPhone1) {
                locationPhones[0] = variables.locationPhone1;
            }
            if (variables.locationPhone2) {
                locationPhones[1] = variables.locationPhone2;
            }
            if (variables.locationPhone3) {
                locationPhones[2] = variables.locationPhone3;
            }

            let locationFaxes = [];
            if (variables.locationFax1) {
                locationFaxes[0] = variables.locationFax1;
            }
            if (variables.locationFax2) {
                locationFaxes[1] = variables.locationFax2;
            }
            if (variables.locationFax3) {
                locationFaxes[2] = variables.locationFax3;
            }

            let locationNursePhones = [];
            if (variables.locationNursePhone1) {
                locationNursePhones[0] = variables.locationNursePhone1;
            }
            if (variables.locationNursePhone2) {
                locationNursePhones[1] = variables.locationNursePhone2;
            }
            if (variables.locationNursePhone3) {
                locationNursePhones[2] = variables.locationNursePhone3;
            }

            let locationAddresses1 = [];
            if (variables.locationAddress11) {
                locationAddresses1[0] = variables.locationAddress11;
            }
            if (variables.locationAddress12) {
                locationAddresses1[1] = variables.locationAddress12;
            }
            if (variables.locationAddress13) {
                locationAddresses1[2] = variables.locationAddress13;
            }

            let locationAddresses2 = [];
            if (variables.locationAddress21) {
                locationAddresses2[0] = variables.locationAddress21;
            }
            if (variables.locationAddress22) {
                locationAddresses2[1] = variables.locationAddress22;
            }
            if (variables.locationAddress23) {
                locationAddresses2[2] = variables.locationAddress23;
            }

            let locationAddresses3 = [];
            if (variables.locationAddress31) {
                locationAddresses3[0] = variables.locationAddress31;
            }
            if (variables.locationAddress32) {
                locationAddresses3[1] = variables.locationAddress32;
            }
            if (variables.locationAddress33) {
                locationAddresses3[2] = variables.locationAddress33;
            }

            let locationCities = [];
            if (variables.locationCity1) {
                locationCities[0] = variables.locationCity1;
            }
            if (variables.locationCity2) {
                locationCities[1] = variables.locationCity2;
            }
            if (variables.locationCity3) {
                locationCities[2] = variables.locationCity3;
            }

            let locationStates = [];
            if (variables.locationState1) {
                locationStates[0] = variables.locationState1;
            }
            if (variables.locationState2) {
                locationStates[1] = variables.locationState2;
            }
            if (variables.locationState3) {
                locationStates[2] = variables.locationState3;
            }

            let locationZips = [];
            if (variables.locationZip1) {
                locationZips[0] = variables.locationZip1;
            }
            if (variables.locationZip2) {
                locationZips[1] = variables.locationZip2;
            }
            if (variables.locationZip3) {
                locationZips[2] = variables.locationZip3;
            }

            let locationSuites = [];
            if (variables.locationSuite1) {
                locationSuites[0] = variables.locationSuite1;
            }
            if (variables.locationSuite2) {
                locationSuites[1] = variables.locationSuite2;
            }
            if (variables.locationSuite3) {
                locationSuites[2] = variables.locationSuite3;
            }

            dispatch(setLocationNames(locationNames));
            dispatch(setLocationPhones(locationPhones));
            dispatch(setLocationFaxes(locationFaxes));
            dispatch(setLocationNursePhones(locationNursePhones));
            dispatch(setLocationAddresses1(locationAddresses1));
            dispatch(setLocationAddresses2(locationAddresses2));
            dispatch(setLocationAddresses3(locationAddresses3));
            dispatch(setLocationCities(locationCities));
            dispatch(setLocationStates(locationStates));
            dispatch(setLocationZips(locationZips));
            dispatch(setLocationSuites(locationSuites));

            dispatch(setFront(variables.front));
            dispatch(setBack(variables.back));
            dispatch(setSuiteRoom(variables.suiteRoom));
            dispatch(setFirstName(variables.firstName));
            dispatch(setMiddleName(variables.middleName));
            dispatch(setLastName(variables.lastName));
            dispatch(setPrimaryTitle(variables.primaryTitle));
            dispatch(setSecondaryTitle(variables.secondaryTitle));
            dispatch(setTitle4(variables.title4));
            dispatch(setMain(variables.main));
            dispatch(setDirect(variables.direct));
            dispatch(setWebsite(variables.website));
            dispatch(setSchedulingCard(variables.schedulingCard));

            if (variables.letterheadPersons) {
                dispatch(setLetterheadPersons(JSON.parse(variables.letterheadPersons)));
            }
            if (variables.prescriptionPadDoctors) {
                dispatch(setPrescriptionPadPersons(JSON.parse(variables.prescriptionPadDoctors)));
            }
        }
    }
}

export const setTemplateCode = (value) => dispatch => {
    dispatch({
        type: types.SET_TEMPLATE_CODE,
        payload: value
    });
}
export const setName = (value) => dispatch => {
    dispatch({
        type: types.SET_NAME,
        payload: value
    });
}
export const setCredentials = (value) => dispatch => {
    dispatch({
        type: types.SET_CREDENTIALS,
        payload: value
    });
}
export const setTitle1 = (value) => dispatch => {
    dispatch({
        type: types.SET_TITLE1,
        payload: value
    });
}
export const setTitle2 = (value) => dispatch => {
    dispatch({
        type: types.SET_TITLE2,
        payload: value
    });
}
export const setTitle3 = (value) => dispatch => {
    dispatch({
        type: types.SET_TITLE3,
        payload: value
    });
}
export const setDepartment1 = (value) => dispatch => {
    dispatch({
        type: types.SET_DEPARTMENT1,
        payload: value
    });
}
export const setDepartment2 = (value) => dispatch => {
    dispatch({
        type: types.SET_DEPARTMENT2,
        payload: value
    });
}
export const setDepartment3 = (value) => dispatch => {
    dispatch({
        type: types.SET_DEPARTMENT3,
        payload: value
    });
}
export const setPhone = (value) => dispatch => {
    dispatch({
        type: types.SET_PHONE,
        payload: value
    });
}
export const setClinic = (value) => dispatch => {
    dispatch({
        type: types.SET_CLINIC,
        payload: value
    });
}
export const setFax = (value) => dispatch => {
    dispatch({
        type: types.SET_FAX,
        payload: value
    });
}
export const setPager = (value) => dispatch => {
    dispatch({
        type: types.SET_PAGER,
        payload: value
    });
}
export const setAddress = (value) => dispatch => {
    dispatch({
        type: types.SET_ADDRESS,
        payload: value
    });
}
export const setAddress2 = (value) => dispatch => {
    dispatch({
        type: types.SET_ADDRESS2,
        payload: value
    });
}
export const setAddress3 = (value) => dispatch => {
    dispatch({
        type: types.SET_ADDRESS3,
        payload: value
    });
}
export const setCity = (value) => dispatch => {
    dispatch({
        type: types.SET_CITY,
        payload: value
    });
}
export const setState = (value) => dispatch => {
    dispatch({
        type: types.SET_STATE,
        payload: value
    });
}
export const setZip = (value) => dispatch => {
    dispatch({
        type: types.SET_ZIP,
        payload: value
    });
}
export const setEmail = (value) => dispatch => {
    dispatch({
        type: types.SET_EMAIL,
        payload: value
    });
}
export const setShowEmail = (value) => dispatch => {
    dispatch({
        type: types.SET_SHOW_EMAIL,
        payload: value
    });
}
export const setOpen1 = (value) => dispatch => {
    dispatch({
        type: types.SET_OPEN1,
        payload: value
    });
}
export const setOpen2 = (value) => dispatch => {
    dispatch({
        type: types.SET_OPEN2,
        payload: value
    });
}
export const setOpen3 = (value) => dispatch => {
    dispatch({
        type: types.SET_OPEN3,
        payload: value
    });
}
export const setQuantity = (value) => dispatch => {
    dispatch({
        type: types.SET_QUANTITY,
        payload: value
    });
}
export const setFrontDataUrl = (value) => dispatch => {
    dispatch({
        type: types.SET_FRONT_DATA_URL,
        payload: value
    });
}
export const setBackDataUrl = (value) => dispatch => {
    dispatch({
        type: types.SET_BACK_DATA_URL,
        payload: value
    });
}
export const setCell = (value) => dispatch => {
    dispatch({
        type: types.SET_CELL,
        payload: value
    });
}
export const setShowCell = (value) => dispatch => {
    dispatch({
        type: types.SET_SHOW_CELL,
        payload: value
    });
}
export const setLocationNames = (value) => (dispatch) => {
    dispatch({
        type: types.SET_LOCATION_NAMES,
        payload: value,
    })
}
export const setLocationPhones = (value) => (dispatch) => {
    dispatch({
        type: types.SET_LOCATION_PHONES,
        payload: value,
    })
}
export const setLocationFaxes = (value) => (dispatch) => {
    dispatch({
        type: types.SET_LOCATION_FAXES,
        payload: value,
    })
}
export const setLocationNursePhones = (value) => (dispatch) => {
    dispatch({
        type: types.SET_LOCATION_NURSE_PHONES,
        payload: value,
    })
}
export const setLocationAddresses1 = (value) => (dispatch) => {
    dispatch({
        type: types.SET_LOCATION_ADDRESSES1,
        payload: value,
    })
}
export const setLocationAddresses2 = (value) => (dispatch) => {
    dispatch({
        type: types.SET_LOCATION_ADDRESSES2,
        payload: value,
    })
}
export const setLocationAddresses3 = (value) => (dispatch) => {
    dispatch({
        type: types.SET_LOCATION_ADDRESSES3,
        payload: value,
    })
}
export const setLocationSuites = (value) => (dispatch) => {
    dispatch({
        type: types.SET_LOCATION_SUITES,
        payload: value,
    })
}
export const setLocationCities = (value) => (dispatch) => {
    dispatch({
        type: types.SET_LOCATION_CITIES,
        payload: value,
    })
}
export const setLocationStates = (value) => (dispatch) => {
    dispatch({
        type: types.SET_LOCATION_STATES,
        payload: value,
    })
}
export const setLocationZips = (value) => (dispatch) => {
    dispatch({
        type: types.SET_LOCATION_ZIPS,
        payload: value,
    })
}
export const setColor = (value) => (dispatch) => {
    dispatch({
        type: types.SET_COLOR,
        payload: value,
    })
}
export const setStock = (value) => (dispatch) => {
    dispatch({
        type: types.SET_STOCK,
        payload: value,
    })
}
export const setTitles = (value) => (dispatch) => {
    dispatch({
        type: types.SET_TITLES,
        payload: value,
    })
}
export const addTitle = () => (dispatch) => {
    dispatch({
        type: types.ADD_TITLE,
        payload: null,
    })
}
export const removeTitle = (count) => (dispatch) => {
    dispatch({
        type: types.REMOVE_TITLE,
        payload: count,
    })
}
export const setPersonsNames = (value) => (dispatch) => {
    dispatch({
        type: types.SET_PERSONS_NAMES,
        payload: value,
    })
}
export const setPersonsTitles = (value) => (dispatch) => {
    dispatch({
        type: types.SET_PERSONS_TITLES,
        payload: value,
    })
}
export const setNotes = (value) => (dispatch) => {
    dispatch({
        type: types.SET_NOTES,
        payload: value,
    })
}
export const setContact1Phone = (value) => (dispatch) => {
    dispatch({
        type: types.SET_CONTACT1_PHONE,
        payload: value,
    })
}
export const setContact1Type = (value) => (dispatch) => {
    dispatch({
        type: types.SET_CONTACT1_TYPE,
        payload: value,
    })
}
export const setContact2Phone = (value) => (dispatch) => {
    dispatch({
        type: types.SET_CONTACT2_PHONE,
        payload: value,
    })
}
export const setContact2Type = (value) => (dispatch) => {
    dispatch({
        type: types.SET_CONTACT2_TYPE,
        payload: value,
    })
}
export const setQuantity1 = (value) => (dispatch) => {
    dispatch({
        type: types.SET_QUANTITY1,
        payload: value,
    })
}
export const setQuantity2 = (value) => (dispatch) => {
    dispatch({
        type: types.SET_QUANTITY2,
        payload: value,
    })
}
export const setQuantity3 = (value) => (dispatch) => {
    dispatch({
        type: types.SET_QUANTITY3,
        payload: value,
    })
}
export const setLocations = (value) => (dispatch) => {
    dispatch({
        type: types.SET_LOCATIONS,
        payload: value,
    })
}
export const addPerson = () => (dispatch) => {
    dispatch({
        type: types.ADD_PERSON,
        payload: null,
    })
}
export const removePerson = (count) => (dispatch) => {
    dispatch({
        type: types.REMOVE_PERSON,
        payload: count,
    })
}
export const setAction = (value) => (dispatch) => {
    dispatch({
        type: types.SET_ACTION,
        payload: value,
    })
}
export const setAddToCartOrderType = (value) => (dispatch) => {
    dispatch({
        type: types.SET_ADD_TO_CART_ORDER_TYPE,
        payload: value,
    })
}
export const setAddToCartType = (value) => (dispatch) => {
    dispatch({
        type: types.SET_ADD_TO_CART_TYPE,
        payload: value,
    })
}
export const setPassword = (value) => (dispatch) => {
    dispatch({
        type: types.SET_PASSWORD,
        payload: value,
    })
}
export const setShowChecks = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SHOW_CHECKS,
        payload: value,
    })
}
export const setFront = (value) => (dispatch) => {
    dispatch({
        type: types.SET_FRONT,
        payload: value,
    })
}
export const setBack = (value) => (dispatch) => {
    dispatch({
        type: types.SET_BACK,
        payload: value,
    })
}
export const setSuiteRoom = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SUITE_ROOM,
        payload: value,
    })
}
export const setFirstName = (value) => (dispatch) => {
    dispatch({
        type: types.SET_FIRST_NAME,
        payload: value,
    })
}
export const setMiddleName = (value) => (dispatch) => {
    dispatch({
        type: types.SET_MIDDLE_NAME,
        payload: value,
    })
}
export const setLastName = (value) => (dispatch) => {
    dispatch({
        type: types.SET_LAST_NAME,
        payload: value,
    })
}
export const setPrimaryTitle = (value) => (dispatch) => {
    dispatch({
        type: types.SET_PRIMARY_TITLE,
        payload: value,
    })
}
export const setSecondaryTitle = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SECONDARY_TITLE,
        payload: value,
    })
}
export const setTitle4 = (value) => (dispatch) => {
    dispatch({
        type: types.SET_TITLE4,
        payload: value,
    })
}
export const setMain = (value) => (dispatch) => {
    dispatch({
        type: types.SET_MAIN,
        payload: value,
    })
}
export const setDirect = (value) => (dispatch) => {
    dispatch({
        type: types.SET_DIRECT,
        payload: value,
    })
}
export const setWebsite = (value) => (dispatch) => {
    dispatch({
        type: types.SET_WEBSITE,
        payload: value,
    })
}
export const setPhoneLabel1 = (value) => (dispatch) => {
    dispatch({
        type: types.SET_PHONE_LABEL1,
        payload: value,
    })
}
export const setPhoneLabel2 = (value) => (dispatch) => {
    dispatch({
        type: types.SET_PHONE_LABEL2,
        payload: value,
    })
}
export const setPhoneLabel3 = (value) => (dispatch) => {
    dispatch({
        type: types.SET_PHONE_LABEL3,
        payload: value,
    })
}
export const setPhoneOtherLabel1 = (value) => (dispatch) => {
    dispatch({
        type: types.SET_PHONE_OTHER_LABEL1,
        payload: value,
    })
}
export const setPhoneOtherLabel2 = (value) => (dispatch) => {
    dispatch({
        type: types.SET_PHONE_OTHER_LABEL2,
        payload: value,
    })
}
export const setPhoneOtherLabel3 = (value) => (dispatch) => {
    dispatch({
        type: types.SET_PHONE_OTHER_LABEL3,
        payload: value,
    })
}
export const setSchedulingCard = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SCHEDULING_CARD,
        payload: value,
    })
}
export const setAddEnvelopes = (value) => (dispatch) => {
    dispatch({
        type: types.SET_ADD_ENVELOPES,
        payload: value,
    })
}
export const addLetterheadPerson = () => (dispatch) => {
    dispatch({
        type: types.ADD_LETTERHEAD_PERSON,
        payload: null,
    })
}
export const removeLetterheadPerson = () => (dispatch) => {
    dispatch({
        type: types.REMOVE_LETTERHEAD_PERSON,
        payload: null,
    })
}
export const setLetterheadPersonName = (index, value) => (dispatch) => {
    dispatch({
        type: types.SET_LETTERHEAD_PERSON_NAME,
        payload: { index, value },
    })
}
export const addLetterheadPersonTitle = (index) => (dispatch) => {
    dispatch({
        type: types.ADD_LETTERHEAD_PERSON_TITLE,
        payload: index,
    })
}
export const removeLetterheadPersonTitle = (index) => (dispatch) => {
    dispatch({
        type: types.REMOVE_LETTERHEAD_PERSON_TITLE,
        payload: index,
    })
}
export const setLetterheadPersonTitle = (personIndex, titleIndex, value) => (dispatch) => {
    dispatch({
        type: types.SET_LETTERHEAD_PERSON_TITLE,
        payload: { personIndex, titleIndex, value },
    })
}
export const setLetterheadPersons = (persons) => (dispatch) => {
    dispatch({
        type: types.SET_LETTERHEAD_PERSONS,
        payload: persons,
    })
}
export const setPrescriptionPadPersons = (persons) => (dispatch) => {
    dispatch({
        type: types.SET_PRESCRIPTION_PAD_PERSONS,
        payload: persons,
    })
}
export const addPrescriptionPadPerson = () => (dispatch) => {
    dispatch({
        type: types.ADD_PRESCRIPTION_PAD_PERSON,
        payload: null,
    })
}
export const removePrescriptionPadPerson = () => (dispatch) => {
    dispatch({
        type: types.REMOVE_PRESCRIPTION_PAD_PERSON,
        payload: null,
    })
}
export const removePrescriptionPadPersonByIndex = (index) => (dispatch) => {
    dispatch({
        type: types.REMOVE_PRESCRIPTION_PAD_PERSON_BY_INDEX,
        payload: index,
    })
}
export const setPrescriptionPadPersonField = (index, field, value) => (dispatch) => {
    dispatch({
        type: types.SET_PRESCRIPTION_PAD_PERSON_FIELD,
        payload: { index, field, value },
    })
}
export const setWindow = (value) => (dispatch) => {
    dispatch({
        type: types.SET_WINDOW,
        payload: value,
    })
}
export const setShowSocialMediaIcons = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SHOW_SOCIAL_MEDIA_ICONS,
        payload: value,
    })
}
export const setAdditionalField = (value) => (dispatch) => {
    dispatch({
        type: types.SET_ADDITIONAL_FIELD,
        payload: value,
    })
}
export const setLanguage = (value) => (dispatch) => {
    dispatch({
        type: types.SET_LANGUAGE,
        payload: value,
    })
}
export const setClinicId = (value) => dispatch => {
    dispatch({
        type: types.SET_CLINIC_ID,
        payload: value
    });
}
export const setLocationId = (value) => dispatch => {
    dispatch({
        type: types.SET_LOCATION_ID,
        payload: value
    });
}
export const setNursePhone = (value) => dispatch => {
    dispatch({
        type: types.SET_NURSE_PHONE,
        payload: value
    });
}
export const setFontType = (value) => dispatch => {
    dispatch({
        type: types.SET_FONT_TYPE,
        payload: value
    });
}

export const resetState = () => (dispatch) => {
    dispatch({
        type: types.RESET_STATE,
        payload: null,
    })
}